import type {SxProps} from '@mui/system';
import {useTheme} from '@mui/material';
import {px2rem} from 'theme';
import {UnstyledButton} from 'components/button/UnstyledButton';
import {Layout} from 'components/layout';
import {Spacer} from 'components/spacer';
import {Text} from 'components/text';

type Props = {
  title: string;
  count: number;
  onClick: () => void;
};

const sxCountSome: SxProps = {
  fontWeight: 'bold',
};

const Content: React.FC<{title: string; count: number}> = ({title, count}) => {
  const {colors} = useTheme();

  const sxButtonSome: SxProps = {
    px: 2,
    background: colors.beige,
    borderRadius: 8,
    height: px2rem(32),
  };

  const sxButtonNone: SxProps = {
    ...sxButtonSome,
    background: colors.beige50,
  };

  const sxTitleNone: SxProps = {
    color: colors.warmGreen,
  };

  const sxCountNone: SxProps = {
    fontWeight: 'bold',
    color: colors.warmGreen,
  };

  return (
    <Layout horizontal adjustCenter sx={count ? sxButtonSome : sxButtonNone}>
      <Text variant={'body1'} sx={count ? undefined : sxTitleNone}>
        {title}
      </Text>
      <Spacer size={1} />
      <Text variant={'body1'} sx={count ? sxCountSome : sxCountNone}>
        {count || '-'}
      </Text>
    </Layout>
  );
};

export const SearchCategoryButton: React.FC<Props> = ({
  title,
  count,
  onClick,
}) => {
  return count > 0 ? (
    <UnstyledButton onClick={onClick}>
      <Content title={title} count={count} />
    </UnstyledButton>
  ) : (
    <Content title={title} count={count} />
  );
};
